import React from 'react';
import { type WrappedComponentProps, injectIntl } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex } from '@atlaskit/primitives';

import { messages } from './messages';

interface ConfluenceReactivationExperimentTabProps {
	title: string;
	isTabClicked: boolean | undefined;
}

const Tab = ({
	intl,
	title,
	isTabClicked,
}: ConfluenceReactivationExperimentTabProps & WrappedComponentProps) => {
	return (
		<Flex alignItems="center" columnGap="space.100">
			{title}
			{!isTabClicked && (
				<Lozenge appearance="new">
					{intl.formatMessage(messages.confluence_availability_tab_more_results)}
				</Lozenge>
			)}
		</Flex>
	);
};

export const ConfluenceAvailabilityExperimentTab = injectIntl(Tab);
